module.exports = __webpack_public_path__ + "img/playstore.fb5073f0.svg";